import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.nav `
  --activeWidth: 2px;
  --colorInactive: ${brand.grey.grey2};
  --colorActive: ${brand.white};
  --direction: row;
  --sizeButton: 17px;
  --sizeDot: 5px;

  display: flex;
  align-self: center;
  flex-direction: var(--direction);
  gap: 8px;
  grid-area: 3 / 1;
  justify-self: flex-start;
  user-select: none;

  @media ${from(Device.Tablet)} {
    --activeWidth: 4px;
    --sizeButton: 33px;
    --sizeDot: 9px;
  }

  @media ${from(Device.TabletLarge)} {
    grid-area: 1 / 1;
    justify-self: flex-end;
  }
`;
const Item = styled.button `
  position: relative;
  display: flex;
  background: transparent;
  border: 0;
  border-radius: 50%;
  color: var(--colorInactive);
  margin: 0;
  padding: 0;
  place-content: center;
  place-items: center;
  height: var(--sizeButton);
  transition: color 0.3s ${cubicEaseOut};
  width: var(--sizeButton);

  &::before {
    content: '';
    background: currentColor;
    border-radius: 50%;
    height: var(--sizeDot);
    transition: background-color 0.3s ${cubicEaseOut};
    width: var(--sizeDot);
  }

  &[aria-current='true'],
  &:focus,
  &:hover {
    color: var(--colorActive);
  }
`;
const ActiveIndicator = styled(m.span) `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  border: var(--activeWidth) solid var(--colorActive);
  border-radius: 50%;
  height: 100%;
  width: 100%;
`;
const SvgIndicator = styled.svg `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  width: 100%;
`;
const Circle = styled(m.circle) `
  fill: none;
  stroke: var(--colorActive);
  stroke-width: 4px;
`;
const DotPaginationStyles = {
    ActiveIndicator,
    Circle,
    Container,
    Item,
    SvgIndicator,
};
export default DotPaginationStyles;
